import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import Widget from "./Widget";
import { X } from "lucide-react";

/**
 * Modal wrapper that renders the full Widget flow inside a centered overlay.
 * On mobile, falls back to full-screen (Dialog handles that natively).
 */
export default function BuyModal({ open, onOpenChange, initialAsset, initialAmount }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-xl w-[calc(100%-1.5rem)] sm:w-full max-h-[92vh] sm:max-h-[92vh] overflow-y-auto p-0 rounded-3xl border-0 bg-transparent shadow-2xl"
        style={{ maxHeight: "min(92vh, calc(100dvh - 2rem))" }}
        data-testid="buy-modal"
      >
        <VisuallyHidden.Root>
          <DialogTitle>Buy crypto</DialogTitle>
          <DialogDescription>Quote, wallet, verification and payment in one flow.</DialogDescription>
        </VisuallyHidden.Root>
        <button
          onClick={() => onOpenChange(false)}
          className="absolute right-3 top-3 z-50 w-9 h-9 rounded-full bg-white/95 hover:bg-white shadow-md flex items-center justify-center text-foreground transition-colors"
          aria-label="Close"
          data-testid="buy-modal-close"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="bg-background rounded-3xl overflow-hidden">
          <Widget
            embedded
            initialAsset={initialAsset}
            initialAmount={initialAmount}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
